import {Pipe, PipeTransform} from '@angular/core';
import {FormAllData, FormStep} from '../../interfaces/forms/form-element';

@Pipe({
    name: 'fieldClasses',
    standalone: false
})
export class FieldClassesPipe implements PipeTransform {
  transform(elem: FormAllData | FormStep): string {
    const el = elem as FormAllData;
    return `${el.class ?? ''} ${el.separator ? ' form-fields-separator' : ''}`;
  }
}
